const RouteTree = ({ routes }: { routes: any[] }) => {
    return (
      <div>
        {routes.map((route, index) => (
          <div key={index} style={{ marginBottom: 8 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                // gap: 8,
                padding: "4px 12px",
                background: "#fafafa",
                borderRadius: 6,
                borderRight: "3px solid #4f46e5",
              }}
            >
              <div>
                <div style={{ fontSize: 12, fontWeight: 400 }}>
                  {route.label}
                </div>

                <div
                  style={{
                    fontSize: 12,
                    color: "#8c8c8c",
                    fontFamily: "monospace",
                  }}
                >
                  {route.path}
                </div>
              </div>
            </div>

            {route.children?.length > 0 && (
              <div
                style={{
                  marginLeft: 24,
                  marginTop: 6,
                  paddingLeft: 12,
                  borderLeft: "1px dashed #4f46e5",
                }}
              >
                <RouteTree routes={route.children} />
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  export default RouteTree;